import { Container, Actions } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { AvatarWithLabel } from '../../dataDisplay/AvatarWithLabel/AvatarWithLabel.js';
import { IconWithLabel } from '../../dataDisplay/IconWithLabel/IconWithLabel.js';

var avatarSizes = {
  small: 'lg',
  medium: '2xl'
};
function EmptyState(props) {
  var icon = props.icon,
    title = props.title,
    description = props.description,
    actions = props.actions,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    withAvatar = props.withAvatar;
  var direction = size === 'small' ? 'vertical' : 'horizontal';
  return /*#__PURE__*/jsxs(Container, {
    className: className,
    children: [withAvatar ? /*#__PURE__*/jsx(AvatarWithLabel, {
      alignment: "vertical",
      appearance: "secondary",
      size: avatarSizes[size],
      title: title,
      subtitle: description,
      truncate: false,
      children: icon
    }) : /*#__PURE__*/jsx(IconWithLabel, {
      alignment: "vertical",
      size: avatarSizes[size],
      title: title,
      subtitle: description,
      truncate: false,
      children: icon
    }), /*#__PURE__*/jsx(Actions, {
      $direction: direction,
      $size: size,
      children: actions
    })]
  });
}

export { EmptyState };
